import type { GameModule } from "../core/types";
import { DodgeGame } from "./dodge/DodgeGame";
import { StackGame } from "./stack/StackGame";
import { RunnerGame } from "./runner/RunnerGame";
import { PopGame } from "./pop/PopGame";

export const games: GameModule[] = [
  {
    id: "dodge",
    title: "Dodge",
    description: "Survis en esquivant. Simple, nerveux, addictif.",
    create: () => new DodgeGame()
  },
  {
    id: "stack",
    title: "Stack",
    description: "Empile les blocs sans les faire tomber.",
    create: () => new StackGame()
  },
  {
    id: "runner",
    title: "Runner",
    description: "Cours le plus loin possible en évitant les obstacles.",
    create: () => new RunnerGame()
  },
  {
    id: "pop",
    title: "Pop",
    description: "Clique/tap les bulles avant qu’elles disparaissent. Combo = gros score.",
    create: () => new PopGame()
  }
];
